(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('bulkGifts', bulkGifts);

    /* @ngInject */
    function bulkGifts() {
        var directive = {
            bindToController: true,
            templateUrl: 'bulk-gifts.tpl',
            controller: bulkGiftsController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };

        return directive;

        function link(scope, element, attrs) {
            scope.vm.other_sections = scope.vm.data.query[0].customs.layout.sections.filter(function(e) {
                return e.type.value != 'form';
            });
            scope.vm.form_sections = scope.vm.data.query[0].customs.layout.sections.filter(function(e) {
                return e.type.value == 'form';
            });
            scope.vm.formData = scope.vm.form_sections[0].form.data;
            scope.vm.formData.bulk_gifts_tmp_id =  {value: 0};
        }
    }

    /* @ngInject */
    function bulkGiftsController ($scope, $http, $cookies) {
        $scope.vm.showForm = false;
        $scope.vm.message = '';

        // ---

        $scope.downloadLink = function(data, linkText) {
            var bin = atob(data.file);
            var buf = new ArrayBuffer(bin.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i != bin.length; ++i) {
                view[i] = bin.charCodeAt(i) & 0xFF;
            }
            var blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'});
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.filename;

            if (linkText) {
                document.querySelector('.download-link').appendChild(document.createTextNode('We detected errors in your upload. '));
                document.querySelector('.download-link').appendChild(link);
                link.innerText = linkText;
                document.querySelector('.download-link').appendChild(document.createTextNode(' to see the errors'));
            } else {
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        };

        // ---

        $scope.getTemplate = function() {
            $scope.ajaxIt({method: 'bulk_gifts_get_template'}, function(r) {
                if (r.result) {
                    $scope.downloadLink(r.payload);
                }
            });
        };

        // ---

        $scope.uploadFile = function() {
            var file = document.querySelector('[name="bulk-gifts-file"]').files[0];
            $scope.ajaxIt({method: 'bulk_gifts_upload', file: file}, function(r) {
                if (r.result) {
                    $scope.vm.formData.bulk_gifts_tmp_id.value = r.payload.tmp_id;
                    setTimeout(function() {
                        $scope.$apply();
                    }, 10);
                    $scope.vm.showForm = true;
                    $scope.vm.summary = r.payload.summary;
                    document.querySelector('.download-link').innerHTML = '';
                    $scope.vm.message = '';
                    $('html, body').animate({
                        scrollTop: document.querySelector('#scroll-here').offsetTop
                    }, 1000);
                } else {
                    $scope.downloadLink(r.payload, r.message);
                    $scope.vm.showForm = false;
                    $scope.vm.summary = '';
                }
            });
        };

        // ---

        $scope.ajaxIt = function(data, callback) {
            $scope.requesting = true;
            $scope.vm.message = '';
            var fd = new FormData();
            fd.append('method', data.method);
            fd.append('action', 'pie_action');
            fd.append('nonce', $scope.$root.stats.nonce);
            if (data.file) {
                fd.append('bulk-gifts-file', data.file, data.file.name);
            }
            $http.post(ajaxurl, fd, {
                headers: { 'Content-Type': undefined},
                transformRequest: angular.identity
            }).then(function(response) {
                if (response.data.payload) {
                    callback(response.data);
                } else if (response.data.message) {
                    $scope.vm.message = response.data.message;
                }
                $scope.requesting = false;
            });
        };

        // ---

        document.querySelector('input[name="bulk-gifts-file"]').addEventListener('change', function(e) {
            if(e.target.files && (e.target.files.length > 0)) {
                document.querySelector('.download-link').innerHTML = '';
                $scope.vm.message = '';
                $scope.vm.fileSelected = true;
                $scope.$evalAsync();
            }
        });
    }

})();